import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { CurrencyAmount } from "./currencyAmount";
import invariant from "tiny-invariant";
import JSBI from "jsbi";
export var TokenAmount = /*#__PURE__*/ function(CurrencyAmount) {
    "use strict";
    _inherits(TokenAmount, CurrencyAmount);
    var _super = _create_super(TokenAmount);
    function TokenAmount(token, amount) {
        _class_call_check(this, TokenAmount);
        var _this;
        _this = _super.call(this, token, amount);
        _this.token = token;
        return _this;
    }
    var _proto = TokenAmount.prototype;
    _proto.add = function add(other) {
        invariant(this.token.equals(other.token), "TOKEN");
        return new TokenAmount(this.token, JSBI.add(this.raw, other.raw));
    };
    _proto.subtract = function subtract(other) {
        invariant(this.token.equals(other.token), "TOKEN");
        return new TokenAmount(this.token, JSBI.subtract(this.raw, other.raw));
    };
    return TokenAmount;
}(CurrencyAmount);
